import { useQuery } from "react-query";
import { GET_OBSERVED_BEHAVIORS_STRENGTHS, STALE_TIME_5_MINUTES } from "@constants/reactQueryKeys";
import { getObservedBehaviorsStrengths } from "api/customers";
import extractRecords from "../utils/extractRecords";

const useGetObservedBehaviorsStrengths = (clientId: number | null) => {
  const { data, isLoading, refetch, ...rest } = useQuery(
    [GET_OBSERVED_BEHAVIORS_STRENGTHS, clientId],
    () => getObservedBehaviorsStrengths(clientId),
    {
      staleTime: STALE_TIME_5_MINUTES,
      enabled: Boolean(clientId),
      refetchOnWindowFocus: false,
    }
  );

  const records = extractRecords(data);
  const observedBehaviorsStrengths = records.length > 0 ? records[0] : null;

  return {
    observedBehaviorsStrengths,
    observedBehaviorsStrengthsLoading: isLoading,
    refetchObservedBehaviorsStrengths: refetch,
    ...rest,
  };
};

export default useGetObservedBehaviorsStrengths;
